import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import colors from "../../../../common/styles/colors";
import { useTranslation } from "react-i18next";
import { ColocatedShowDataSyncStatus } from "../../../../common/enums";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { SNACKBAR_VARIANTS } from "../../../../common/constants";

export const ColocatedShowDataSyncChip = () => {
  const { t } = useTranslation("common");
  const { enqueueSnackbar } = useSnackbar();
  const { colocatedShowDataSyncVisible, colocatedShowDataSyncStatus, colocatedShowDataSyncProgress } = useSelector(
    (state: RootState) => state.metadata
  );

  const progress = Math.max(0, Math.min(100, colocatedShowDataSyncProgress ?? 0));

  useEffect(() => {
    if (colocatedShowDataSyncStatus === ColocatedShowDataSyncStatus.SYNCING) {
      enqueueSnackbar(<b>{t("header.colocatedShowDataSync.syncingTooltip")}</b>, SNACKBAR_VARIANTS.warning);
    }

    if (colocatedShowDataSyncStatus === ColocatedShowDataSyncStatus.FAILED) {
      enqueueSnackbar(<b>{t("header.colocatedShowDataSync.failedTooltip")}</b>, SNACKBAR_VARIANTS.error);
    }
  }, [colocatedShowDataSyncStatus]);

  if (!colocatedShowDataSyncVisible) return null;

  return colocatedShowDataSyncStatus === ColocatedShowDataSyncStatus.FAILED ? (
    <Chip
      data-testid="colocated-show-data-sync-chip"
      size="small"
      label={t("header.colocatedShowDataSync.failedLabel")}
      icon={<ErrorOutlineIcon fontSize="large" color={"error"} />}
      sx={{
        whiteSpace: "nowrap",
        backgroundColor: "transparent",
        color: colors.red[800],
        fontSize: "13px"
      }}
    />
  ) : (
    <Chip
      data-testid="colocated-show-data-sync-chip"
      size="small"
      label={t("header.colocatedShowDataSync.syncingLabel", { progress })}
      icon={<CircularProgress size={24} thickness={4.5} value={progress} variant="determinate" color={"warning"} />}
      sx={{
        whiteSpace: "nowrap",
        backgroundColor: "transparent",
        color: colors.darkGrey1,
        fontSize: "13px",
        paddingLeft: "10px",
        fontWeight: 600
      }}
    />
  );
};
